export const shadows = {
  outline: '0 0 0 3px #99B6FF', // Original value was (Chakra default) 0 0 0 3px rgba(66, 153, 225, 0.6)
};
